import {
  getPlantProfiles, getRoles, setPlantProfile, setRole, setLang,
  simulateHardware, reasonMessage,
} from '../mockStore.js';
import { t } from '../i18n.js';

export function renderSettings(root, state, { canControl }) {
  const lang = state.lang;
  const profiles = getPlantProfiles();
  const roles = getRoles();

  root.innerHTML = `
    <div class="view">
      <h2 class="view-title">${t(lang, 'settings')}</h2>
      <div class="grid grid-2">
        <div class="card controls-only">
          <h3>植物檔案（參數，唔改硬件）</h3>
          <select data-profile style="width:100%;height:32px;border:1px solid var(--border-dark);border-radius:3px;padding:0 8px">
            ${profiles.map((p) => `<option value="${p.id}" ${state.plantProfileId === p.id ? 'selected' : ''}>${lang === 'en' ? p.nameEn : p.name}</option>`).join('')}
          </select>
          <div class="meta" style="margin-top:8px">一按轉作物參數；硬件接線不變。</div>
        </div>
        <div class="card">
          <h3>語言</h3>
          <div class="btn-row">
            <button type="button" class="btn sm ${lang === 'zh-Hant' ? 'primary' : ''}" data-lang="zh-Hant">粵／繁</button>
            <button type="button" class="btn sm ${lang === 'zh-Hans' ? 'primary' : ''}" data-lang="zh-Hans">简体</button>
            <button type="button" class="btn sm ${lang === 'en' ? 'primary' : ''}" data-lang="en">EN</button>
          </div>
          <h3 style="margin-top:14px">角色 stub</h3>
          <div class="btn-row">
            ${roles.map((r) => `
              <button type="button" class="btn sm ${state.role === r.id ? 'primary' : ''}" data-role="${r.id}">${r.label}</button>
            `).join('')}
          </div>
          <div class="meta">Viewer = 只可睇 3D／狀態，控制掣 disabled。</div>
        </div>
        <div class="card">
          <h3>通知 stub</h3>
          <div class="meta">推送通道未定（FCM／APNs／電郵／WhatsApp？）— 等 Sam 決定。而家只係佔位。</div>
          <label class="toggle-row"><span class="label">警報推送（假）</span><input type="checkbox" disabled /></label>
          <label class="toggle-row"><span class="label">每日摘要（假）</span><input type="checkbox" disabled /></label>
        </div>
        <div class="card">
          <h3>示範用：模擬硬件狀態</h3>
          <div class="meta">只影響 mock；真棚硬件互鎖仍係現場。</div>
          <div class="btn-row">
            <button type="button" class="btn sm" data-sim="estop">觸發急停</button>
            <button type="button" class="btn sm" data-sim="clearhw">清除硬件旗標</button>
            <button type="button" class="btn sm" data-sim="lowwater">模擬低水位</button>
            <button type="button" class="btn sm" data-sim="wind">模擬強風 14m/s</button>
            <button type="button" class="btn sm" data-sim="co2">模擬 CO₂ 高</button>
          </div>
        </div>
      </div>
      <div id="set-toast" class="lock-reason" style="display:none;margin-top:10px"></div>
    </div>
  `;

  const toast = root.querySelector('#set-toast');
  root.querySelector('[data-profile]')?.addEventListener('change', (ev) => {
    const r = setPlantProfile(ev.target.value);
    if (!r.ok) { toast.style.display = 'block'; toast.textContent = reasonMessage(r.reason, lang); }
  });
  root.querySelectorAll('[data-lang]').forEach((btn) => {
    btn.addEventListener('click', () => setLang(btn.dataset.lang));
  });
  root.querySelectorAll('[data-role]').forEach((btn) => {
    btn.addEventListener('click', () => setRole(btn.dataset.role));
  });
  root.querySelectorAll('[data-sim]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const k = btn.dataset.sim;
      if (k === 'estop') simulateHardware({ eStop: true });
      if (k === 'clearhw') simulateHardware({ eStop: false, rcdTrip: false, overload: false, typhoonFieldLock: false });
      if (k === 'lowwater') simulateHardware({ lowWater: true });
      if (k === 'wind') simulateHardware({ windMs: 14 });
      if (k === 'co2') simulateHardware({ co2High: true });
    });
  });
}
